import { call, put, select } from 'redux-saga/effects';

import {
    addToWishlist,
    checkWishlists,
    saveFormValidation,
    showCannotAddToListError,
    hideCannotAddToListError
} from '../actions/productActions';

import {
    hideRegistriesFromWishlist
} from '../actions/productRegistryActions';

import {
    isFormValid,
    buildErrorsFromResponse
} from '../../../core/js/utils/errorHandling';

import { error, warn } from '../../../core/js/utils/logger';

import template from 'product-wishlist-add.j2';

import { moveToWishListSaga } from '../sagas/productWishListSagas';

import {
    delay
} from '../../../core/js/utils';

import productConfig from '../configs/config';

import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';
import { mDom } from '../../../core/js/utils/renderUtils';

function *formValidation(e, action, params, component) {
    let state = yield select();
    const formEl = $(component.templateLocation).parents('.js-product-add-form');

    if (formEl.length > 0) {
        if (isFormValid(formEl)) {
            yield put(hideCannotAddToListError(component));
            yield put(action(params, e, component));
        } else {
            yield put(showCannotAddToListError(component));
        }
    } else if (params) {
        yield put(action(params, e, component));
    } else {
        yield put(action(undefined, e, component));
    }
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    let meta = {
        component: this
    };

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-create-wishlist-ui'), (e) => {
        e.preventDefault();

        // Hide registry list
        store.dispatch(hideRegistriesFromWishlist({}, meta));

        const product = this.getTargetedProduct(store.getState(), this);
        const noWishLists = _.isUndefined(product.productAddToWishList.wishlists);

        // If there are no Wishlists retrieved yet, go through the whole process
        // Otherwise, simply re-show the UI
        if (noWishLists) {
            store.runSaga(formValidation, e, checkWishlists, undefined, this);
        } else {
            // is-open with jquery rather than based on whether wishlists exists in the store
            $(this.scopedSelector('.js-create-wishlist-ui')).toggleClass('is-open');
            $(this.scopedSelector()).siblings('.dom-wishlist-list')
                .find('.js-product-add-links__ul')
                .toggle();
        }
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-add-to-wishlist'), (e) => {
        e.preventDefault();
        const target = $(e.target);
        const id = target.attr('data-wishlistid');
        const name = target.attr('data-wishlistname');
        const params = {
            id: id,
            name: name,
            fromDropdown: true
        };

        store.runSaga(formValidation, e, addToWishlist, params, this);
    });

    $(document).on(this.scopedEvent('change'), '.js-move-to-different-list', (e) => {
        e.preventDefault();
        const target = $(e.target);
        const id = target.val();
        const params = {
            id: id
        };

        const meta = {
            event: e,
            component: this,
            store: store
        };

        store.runSaga(moveToWishListSaga, params, meta).done.then(() => {
            delay(productConfig.cartConfirm.initialHideDelay);

            // IE support
            window.location = window.location;
        }).catch((err) => {
            error(`error moving to wishlist: ${error}`);
            if (error.entity) {
                const messages = buildErrorsFromResponse(error);

                if (error.entity.field_errors) {
                    store.dispatch(saveFormValidation({}, messages, {}, this));
                }
            } else {
                warn('Unable to move to wishlist.', error);
            }
        });
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-wishlist-add',
        onStateChange: onStateChange,
        attachEvents: attachEvents,
        watch: ['product.productAddToWishList', 'product.hideListAddLinks'],
        template: template,
        name: 'productWishListComponent',
        renderType: mDom,
        forFamilyProduct: false,
        listName: 'WISHLIST'
    };

    return generate(config, store, overrides);
}
